module.exports = __webpack_public_path__ + "static/media/medicheck_logo.f0c0f622.png";